import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/film";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px] gap-4">
          <button
            type="button"
            onClick={() => scrollTo("top")}
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-film-line text-lg" />
            </span>
            <span className="flex flex-col items-start leading-none">
              <span
                className={`font-heading font-bold text-base md:text-lg ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                一路向西在线
              </span>
              <span
                className={`font-label text-[10px] tracking-widest uppercase mt-0.5 ${
                  scrolled ? "text-foreground-500" : "text-background-200"
                }`}
              >
                Plot · Review · Easter Eggs
              </span>
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => scrollTo(link.id)}
                className={`px-3 py-2 rounded-md font-label text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-600 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-100 hover:text-background-50 hover:bg-white/10"
                }`}
              >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center shrink-0">
            <button
              type="button"
              onClick={() => scrollTo("plot")}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 font-label text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-line" />
              从剧情开始
            </button>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="lg:hidden bg-background-50 border-b border-background-200">
          <div className="px-4 py-4 grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => scrollTo(link.id)}
                className="px-3 py-3 rounded-md bg-background-100 text-foreground-700 font-label text-sm text-left hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}